import {
  alertMessagesArgsConfig,
  collectionArgsConfig,
  collectionFieldArgsConfig,
  getItemIdFromArgsConfig,
  redirectUrlArgsConfig,
  retainUrlParamsArgsConfig,
} from '../../utils/event_constants';

export const zoomActions = [
  {
    name: 'initiateZoomAuth',
    label: 'Initiate Zoom Auth',
    args: [...redirectUrlArgsConfig, retainUrlParamsArgsConfig, ...alertMessagesArgsConfig],
  },
  {
    name: 'createInstantZoomMeet',
    label: 'Create an Instant Zoom Meet',
    args: [
      collectionArgsConfig,
      collectionFieldArgsConfig({ name: 'summaryField', label: 'Select Meeting Title Field' }),
      collectionFieldArgsConfig({ name: 'descriptionField', label: 'Meeting Description Field' }),
      ...getItemIdFromArgsConfig,
      collectionFieldArgsConfig({
        name: 'durationField',
        label: 'Select Event Duration Field (in minutes)',
      }),
      ...alertMessagesArgsConfig,
    ],
  },
];
